/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19.725 3.225c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05l-16.5 16.5c-.225.3-.75.3-1.05 0-.3-.3-.3-.75 0-1.05l2.473-2.473C4.506 15.642 3.75 13.65 3.75 11.55V6.075c0-.675.45-1.35 1.125-1.65C7.125 3.45 9.525 3 12 3c2.32 0 4.575.396 6.702 1.248l1.023-1.023ZM7.5 19.05c.75.6 1.65 1.125 2.625 1.425l.825.3c.675.225 1.5.225 2.175 0l.825-.3a9.649 9.649 0 0 0 6.375-8.925V6.3L7.5 19.05Z"
})), "0 0 24 24", "InsuranceOff");